import { BrowserSessionApiClient } from './browserSessionApiClient';
export type ProvisionMatch = { blockId: number; documentId: number; ingestionRunId: number | null; pageNumber: number | null; text: string; heading: string | null; title: string; version: string | null; sourcePath: string | null };
const client = new BrowserSessionApiClient('');
export async function checkKnowledgeProvisions(documentId: number, query: string): Promise<ProvisionMatch[]> {
  const result = await client.request<{ data: ProvisionMatch[] }>(`/api/v1/knowledge/search?mode=provision&documentId=${documentId}&q=${encodeURIComponent(query)}`);
  return result.data;
}
